import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateContactDirectories = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 203,
	height: 200,
	viewBox: "0 0 203 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M100.593 200C155.821 200 200.593 155.228 200.593 100C200.593 44.7715 155.821 0 100.593 0C45.3643 0 0.592773 44.7715 0.592773 100C0.592773 155.228 45.3643 200 100.593 200Z",
			fill: "#FAFCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.383 34.793H60.8248C59.7059 34.793 58.7988 35.7 58.7988 36.8189V166.491C58.7988 167.61 59.7059 168.517 60.8248 168.517H200.383C201.502 168.517 202.409 167.61 202.409 166.491V36.8189C202.409 35.7 201.502 34.793 200.383 34.793Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.463 49.0801H72.7539V68.1603H188.463V49.0801Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.392 49.0801H72.7539V68.1603H105.392V49.0801Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.921 104.404C154.921 111.316 152.04 117.548 147.409 121.973C143.049 126.15 137.125 128.715 130.61 128.715C124.095 128.715 118.179 126.158 113.811 121.981C109.18 117.556 106.299 111.32 106.299 104.404C106.299 90.9801 117.178 80.0928 130.61 80.0928C144.042 80.0928 154.921 90.9801 154.921 104.404Z",
			fill: "#FAFCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.406 121.973C143.046 126.151 137.122 128.716 130.607 128.716C124.091 128.716 118.176 126.159 113.808 121.981C114.881 114.996 120.206 109.425 127.049 107.97C123.455 106.552 120.902 103.051 120.902 98.9425C120.902 93.5819 125.246 89.2383 130.607 89.2383C135.967 89.2383 140.311 93.5819 140.311 98.9425C140.311 103.051 137.758 106.552 134.156 107.97C141 109.425 146.324 115 147.402 121.973H147.406Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M169.994 152.662H91.2173C90.1297 152.662 89.248 153.543 89.248 154.629C89.248 155.716 90.1297 156.596 91.2173 156.596H169.994C171.081 156.596 171.963 155.716 171.963 154.629C171.963 153.543 171.081 152.662 169.994 152.662Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.605 141.637H128.345C127.258 141.637 126.376 142.517 126.376 143.604C126.376 144.69 127.258 145.571 128.345 145.571H133.605C134.692 145.571 135.574 144.69 135.574 143.604C135.574 142.517 134.692 141.637 133.605 141.637Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.104 141.637H108.495C107.407 141.637 106.525 142.517 106.525 143.604C106.525 144.69 107.407 145.571 108.495 145.571H121.104C122.192 145.571 123.073 144.69 123.073 143.604C123.073 142.517 122.192 141.637 121.104 141.637Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.716 141.637H140.107C139.019 141.637 138.138 142.517 138.138 143.604C138.138 144.69 139.019 145.571 140.107 145.571H152.716C153.804 145.571 154.686 144.69 154.686 143.604C154.686 142.517 153.804 141.637 152.716 141.637Z",
			fill: "#B5C5EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.3745 56.6523H82.7651C81.6775 56.6523 80.7959 57.5331 80.7959 58.6195C80.7959 59.706 81.6775 60.5867 82.7651 60.5867H95.3745C96.4621 60.5867 97.3437 59.706 97.3437 58.6195C97.3437 57.5331 96.4621 56.6523 95.3745 56.6523Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M66.234 96.1992H29.4269C27.1735 96.1992 25.3467 98.026 25.3467 100.279V128.043C25.3467 130.296 27.1735 132.123 29.4269 132.123H66.234C68.4875 132.123 70.3143 130.296 70.3143 128.043V100.279C70.3143 98.026 68.4875 96.1992 66.234 96.1992Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.074 94.4199H27.1534C24.9313 94.4199 23.1299 96.2213 23.1299 98.4434V126.32C23.1299 128.542 24.9313 130.344 27.1534 130.344H64.074C66.2961 130.344 68.0975 128.542 68.0975 126.32V98.4434C68.0975 96.2213 66.2961 94.4199 64.074 94.4199Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 19.1235,
			height: 19.1235,
			transform: "translate(36.4492 101.992)",
			fill: "white",
			fillOpacity: .01
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.3501 103.681C45.3272 103.156 48.1819 104.858 49.2045 107.591C49.9002 107.444 50.628 107.46 51.3354 107.649C53.7796 108.304 55.2301 110.817 54.5751 113.261C54.3229 114.202 53.7862 115.022 53.0458 115.625C52.6193 115.973 51.9919 115.909 51.6445 115.482C51.2971 115.056 51.3611 114.428 51.7876 114.081C52.2061 113.74 52.508 113.279 52.651 112.745C53.0212 111.364 52.2013 109.944 50.8198 109.573C50.2438 109.419 49.648 109.468 49.1136 109.701C49.0687 109.721 49.023 109.737 48.977 109.75C48.8907 109.794 48.7964 109.826 48.696 109.844C48.1543 109.939 47.6377 109.578 47.5421 109.036C47.141 106.761 44.9713 105.241 42.696 105.643C40.4208 106.044 38.9015 108.213 39.3027 110.489C39.4248 111.181 39.7124 111.817 40.138 112.355C40.3161 112.58 40.5171 112.786 40.7376 112.97C41.1596 113.323 41.2158 113.951 40.863 114.373C40.5103 114.795 39.8821 114.852 39.4601 114.499C39.1351 114.227 38.8387 113.923 38.5758 113.591C37.9465 112.795 37.5207 111.854 37.3409 110.835C36.7487 107.476 38.9914 104.273 42.3501 103.681ZM48.6059 115.646L47.2073 114.247V118.726C47.2073 119.276 46.7614 119.722 46.2113 119.722C45.6612 119.722 45.2153 119.276 45.2153 118.726V114.247L43.8167 115.646C43.4277 116.035 42.7971 116.035 42.4081 115.646C42.0191 115.257 42.0191 114.626 42.4081 114.237L45.507 111.138C45.5556 111.09 45.608 111.047 45.6632 111.011C46.0498 110.755 46.5752 110.798 46.9156 111.138M46.9171 111.14L50.0144 114.237C50.4034 114.626 50.4034 115.257 50.0144 115.646C49.6255 116.035 48.9948 116.035 48.6059 115.646",
			fill: "white"
		})
	]
});
export default SvgEmptyStateContactDirectories;
